import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import SwiperCore, { Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import Container from '@/components/foundations/content';
import { StaticImage } from 'gatsby-plugin-image';
import * as styles from './service.module.scss';

import InfoSvg from '@/svgs/icon/info';

const ServiceContent: React.FC = ({ inView }: any) => {
  SwiperCore.use([Autoplay]);
  const [swiper, setSwiper] = useState<SwiperCore | null>(null);
  const [slideIndexState, setSlideIndexState] = useState<number>(0);

  const controllerStyle = classNames(styles.oService__controller);

  const controllerChildStyle = [...Array(4)].map((number, index) => {
    return classNames(slideIndexState === index && styles.active);
  });

  const swiperChange = (swiper: SwiperCore) => {
    setSlideIndexState(swiper.realIndex);
  };

  const controllerOnClick = (number: number) => {
    swiper && swiper.slideToLoop(number);
  };

  useEffect(() => {
    if (inView && swiper) {
      swiper.slideToLoop(0);
      swiper.autoplay.start();
    }
  }, [inView]);

  return (
    <>
      <h2>
        <span>
          <strong>Service</strong>
          <small>提供内容</small>
        </span>
      </h2>
      <h3>４つのプロセスに沿ってレビューを実施します。</h3>
      <div className={styles.oService__slider}>
        <ul className={controllerStyle}>
          <li className={controllerChildStyle[0]} onClick={() => controllerOnClick(0)}>
            ヒアリング
          </li>
          <li className={controllerChildStyle[1]} onClick={() => controllerOnClick(1)}>
            評価設計
          </li>
          <li className={controllerChildStyle[2]} onClick={() => controllerOnClick(2)}>
            評価実施
          </li>
          <li className={controllerChildStyle[3]} onClick={() => controllerOnClick(3)}>
            サンプル画面/<br />UIデザイン方針 作成
          </li>
        </ul>
        <div className={styles.oService__sliderMain}>
          <Swiper
            className={styles.oService__swiper}
            autoplay={true}
            loop={true}
            loopedSlides={2}
            onActiveIndexChange={swiperChange}
            onSwiper={setSwiper}
          >
            <SwiperSlide className={styles.oService__slider__slide}>
              <h4>ヒアリング</h4>
              <p>
                設計対象の背景/課題/目的/対象ユーザー/ドメインに依存する専門的な考慮点をヒアリングし、評価対象を理解します。
              </p>
            </SwiperSlide>
            <SwiperSlide className={styles.oService__slider__slide}>
              <h4>評価設計</h4>
              <p>
                想定するユースケースをもとに、テストシナリオを作成します。その後、採用するユーザービリティガイドライン及び、その他考慮の必要な点をリスト化し、評価者を複数名設定します。
              </p>
            </SwiperSlide>
            <SwiperSlide className={styles.oService__slider__slide}>
              <h4>評価実施</h4>
              <p>
                評価者がシナリオに添い評価を行い、改善点についてレビュー内容をまとめます。各評価者からの改善点を統合し、レポートを作成します。
                <br />
                <small>※適切な結果を得るために3名以上の評価者による評価を原則とします。</small>
              </p>
            </SwiperSlide>
            <SwiperSlide className={styles.oService__slider__slide}>
              <h4>サンプル画面/UIデザイン方針 作成</h4>
              <p>
                評価内容をもとに、改善案を踏まえた画面のサンプルデザインの作成や、プロダクトで共通とすべきUIのデザイン方針を定義します。作成する内容とボリュームはサービスやプロダクトにより変動します。
              </p>
            </SwiperSlide>
          </Swiper>
          <Character index={slideIndexState} />
        </div>
      </div>
      <p className={styles.oService__attention}>
        <InfoSvg />
        個別画面のデザインや開発もご要望に応じて対応いたします。是非ご相談ください。
      </p>
    </>
  );
};

const Character: React.FC<{ index: number }> = ({ index }) => {
  interface mappingType {
    [key: string]: String;
  }

  const mapping: mappingType = {
    1: styles.visible1,
    2: styles.visible2,
    3: styles.visible3,
    4: styles.visible4,
  };

  const style = classNames(styles.oService__charactor, mapping[`${index + 1}`]);
  return (
    <ul className={style}>
      <li>
        <StaticImage src="./img/research.png" alt="調査" />
      </li>
      <li>
        <StaticImage src="./img/analyze.png" alt="分析" />
      </li>
      <li>
        <StaticImage src="./img/create.png" alt="作成" />
      </li>
      <li>
        <StaticImage src="./img/assessment.png" alt="評価" />
      </li>
    </ul>
  );
};

const Conversion: React.FC = () => {
  return (
    <Container
      className={{ wrapper: styles.oService, inner: styles.lContent__inner }}
      intersection={{ visible: styles.visible, standby: styles.standby }}
    >
      <ServiceContent />
    </Container>
  );
};

export default Conversion;
